import { ProgressBar } from '@blueprintjs/core';
import { BOSToasterRef } from 'Components/Generic/BOSToaster';
import styles from './BOSToaster.module.css';

export const getSaveToasterProps = (extraProps) => {
  return {
    intent: 'success',
    icon: 'saved',
    message: 'Saved',
    isCloseButtonShown: false,
    timeout: 2000,
    ...extraProps,
  };
};

const getLoginToastProps = (navigateAction) => {
  return {
    message: 'Oops! You need to log in first!',
    icon: 'warning-sign',
    timeout: 2000,
    intent: 'danger',
    isCloseButtonShown: false,
    onDismiss: navigateAction,
    action: {
      onClick: navigateAction,
      text: 'Login',
    },
  };
};

export const showLoginNeededToast = (navigateAction) => {
  BOSToasterRef.clear();
  BOSToasterRef.show(getLoginToastProps(navigateAction));
};

export const getUndoToasterProps = (extraProps) => {
  return {
    intent: 'success',
    icon: 'refresh',
    message: 'Reverted',
    timeout: 800,
    ...extraProps,
  };
};

export const getHasBeenDeletedToasterProps = (message, extraProps) => {
  return {
    intent: 'danger',
    icon: 'trash',
    message: message,
    timeout: 2000,
    ...extraProps,
  };
};

export const showSaveSuccessToast = (message) => {
  BOSToasterRef.show({
    intent: 'success',
    icon: 'saved',
    message: message,
    timeout: 2000,
  });
};

export const showSuccessToast = (message) => {
  BOSToasterRef.show({
    intent: 'success',
    icon: 'tick',
    message: message,
    timeout: 2000,
  });
};

export const showToast = (message, intent, icon, timeout = 2000) => {
  BOSToasterRef.show({
    intent: intent || 'success',
    icon: icon,
    message: message,
    timeout: timeout,
  });
};

export const clearToasts = () => {
  BOSToasterRef.clear();
};

export const showLoadingToast = (
  text = '',
  icon = 'refresh',
  timeout = 8000,
) => {
  handleProgressToast({
    text,
    icon,
    timeout,
  });
};

const getProgressToastProps = ({ text, icon, timeout, progress = 0 }) => {
  let message = getProgressMessage(text, progress);
  return { message, icon, timeout, className: styles.vert_align_middle };
};
const getProgressMessage = (text, progress) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {text}
      <ProgressBar
        stripes={progress < 100}
        intent={progress >= 100 ? 'success' : 'primary'}
        value={progress / 100}
      />
    </div>
  );
};

let progressToastInterval;
let progressToastKey;

const handleProgressToast = (props) => {
  let progress = 0;
  progressToastKey = BOSToasterRef.show(
    getProgressToastProps({ progress, ...props }),
  );
  progressToastInterval = window.setInterval(() => {
    if (!progressToastKey || progress > 95) {
      window.clearInterval(progressToastInterval);
    } else {
      progress += 10 + Math.random() * 20;
      BOSToasterRef.show(
        getProgressToastProps({ progress, ...props }),
        progressToastKey,
      );
    }
  }, 100);
};

export const showLoadingDoneToast = (
  text = '',
  icon = 'automatic-updates',
  timeout = 2000,
) => {
  BOSToasterRef.show(
    getProgressToastProps({
      text,
      icon,
      timeout,
      progress: 100,
    }),
    progressToastKey,
  );
  window.clearInterval(progressToastInterval);
};
